import styled, { css } from "styled-components";
import { staffLines } from "../../../../common/styles";
import { amazonHost } from "../../../paths";

export const StyledWhy = styled.div`
    padding-top: 10px;
    padding-bottom: 48px;
    background-color: ${p => p.theme.c.dark};
    position: relative;
    background-size: 100% 109.3%;

    ${staffLines}

    display: flex;
    flex-direction: column;
    font-size: 24px;
    font-weight: 300;
    color: ${p => p.theme.c.boost};

    ${p =>
        p.theme.sm.max(css`
            padding-bottom: 32px;
        `)}

    ${p =>
        p.theme.xs(css`
            padding-bottom: 16px;
        `)}

    &:before {
        content: "";
        height: 25px;
        background-color: ${p => p.theme.c.info};
        width: 100%;
        position: absolute;
        top: -24px;
        left: 0;
    }
`;

export const H2 = styled.h2`
    font-size: 38px;
    text-transform: uppercase;
    text-align: center;
    color: ${p => p.theme.c.info};
    margin-bottom: 0;

    ${p =>
        p.theme.md.only(css`
            font-size: 32px;
        `)}

    ${p =>
        p.theme.sm.max(css`
            font-size: 30px;
            margin-bottom: 10px;
        `)}
`;

export const Wrapper = styled.div`
    margin: 0 120px;
    ${p =>
        p.theme.sm.only(css`
            margin: 0 32px;
        `)}
    ${p =>
        p.theme.xs(css`
            margin: 0 16px;
        `)}
`;

export const CategoryTitle = styled.h3`
    color: ${p => p.theme.c.whiteOnActive};
    font-size: 28px;
    ${p =>
        p.theme.xs(css`
            margin: 8px 0 12px;
            font-size: 24px;
        `)}
`;

export const Language = styled.div`
    display: flex;
    margin-bottom: 12px;
`;

export const FlagWrapper = styled.div`
    margin-right: 24px;
    img {
        box-shadow: 0 0 6px 0 ${p => p.theme.c.blackShadow3};
    }
`;

export const Flag = styled.img`
    width: 72px;
    margin-top: 2px;
`;

export const Translators = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

export const UserWrapper = styled.div`
    margin-right: 24px;
    display: inline-block;
    margin-bottom: 16px;
`;

export const CategoryBox = styled.div`
    background-color: ${p => p.theme.c.light};
    border-radius: 16px;
    padding: 20px;
    padding-bottom: 0;
`;

export const Sentry = styled.img`
    width: 260px;
    display: block;
`;

export const Bvk = styled.div`
    width: 245px;
    height: 82px;
    display: block;
    background: url("${amazonHost}landing/bvk-logo.jpg");
    background-size: 975px;
    box-shadow: 0 0 5px 0 ${p => p.theme.c.blackShadow3};
    background-position: -3px -50px;
`;

export const GraphicPositioner = styled.div`
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    font-weight: 400;

    a {
        margin-right: 12px;
        display: flex;
        align-items: center;
    }
    svg {
        display: block;
        path {
            stroke: ${p => p.theme.c.boost};
        }

        .circle {
            fill: ${p => p.theme.c.boost};
        }
    }
`;

export const PartnersPositioner = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-bottom: 20px;

    a {
        margin-bottom: 20px;
    }

    ${p =>
        p.theme.xs(css`
            flex-direction: column;
            a {
                margin-bottom: 12px;
            }
        `)}
`;

export const KodalyIreland = styled.img`
    width: 340px;
    ${p =>
        p.theme.xs(css`
            width: 260px;
        `)}
`;

export const Kam = styled.img`
    width: 120px;
`;

export const Aikem = styled.img`
    width: 246px;
    box-shadow: 0 0 5px 0 ${p => p.theme.c.blackShadow3};
`;

export const LastRow = styled.div`
    ${p =>
        p.theme.sm.min(css`
            display: flex;
            > div {
                flex: 1;
            }

            > div:first-of-type {
                margin-right: 32px;
            }
        `)}
`;

export const Alexandra = styled.img`
    width: 56px;
    margin: -6px 14px -10px -7px;
    height: 56px;
    border-radius: 28px;
    border: 2px solid ${p => p.theme.c.boost};
    box-sizing: border-box;
`;
